module.exports = __webpack_public_path__ + "img/95591723018409.67e4f6d0.png";